import UIImageComponent from '../../../Component/UI/Image';
import Game from '../../../Game';
import GameObject from '../../../GameObject/GameObject';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import Element from '../../../Prototype/UI/Element';
import { GameActions } from '../../../State/Game/GameActions';
import { ContextType } from '../../../State/Game/IContext';
import { UserActions } from '../../../State/User/UserActions';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import BaseUISystem from '../BaseUISystem';
import { getLoadCrossPromoPromise } from '../HUD/CrossPromoHUD';
import {
    applyBounceButtonAnimation,
    applyDefaultButtonAnimation,
} from '../UIHelper';
import BaseMenu from './BaseMenu';

const BTN_CLOSE: string = 'main_container/close_button';
const BTN_PLAY: string = 'main_container/play_button';
const DECO_CENTER: string = 'main_container/deco_center';

export default class CrossPromoMenu extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('crossPromoMenu', uiSystem);
    }

    protected onShow(params?: any): void {
        Game.sdk.gameTracking(FBTrackingEvent.xPromo_Show);
    }

    protected onCreate(): void {
        this.prepareCrossPromo();
    }

    private async prepareCrossPromo() {
        const crossPromoData = await getLoadCrossPromoPromise();

        if (!crossPromoData || !this.active) return;

        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        btnClose.on(GameObjectEvent.SELECTED, () => {
            Game.sdk.gameTracking(FBTrackingEvent.xPromo_Close);
            this.system.state.dispatch(UserActions.dismissCrossPromo());
        });
        applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);

        // Button subscribe.
        const btnPlay = this.element.find(BTN_PLAY);
        btnPlay.on(GameObjectEvent.SELECTED, () => {
            Game.sdk.gameTracking(FBTrackingEvent.xPromo_Accept);
            Game.state.dispatch(
                GameActions.setContext(ContextType.SWITCH_GAME, {
                    gameId: crossPromoData.xPromoData.gameId,
                })
            );
        });
        applyBounceButtonAnimation(btnPlay, AUDIO_UI_BUTTON_DEFAULT);

        const decoCenter = this.element.find(DECO_CENTER);

        // Create header image
        const image = GameObject.Instantiate(Element);
        image.addComponent(UIImageComponent, {
            type: 'image',
            data: {
                cacheKey: 'xpromo_header',
            },
        });
        decoCenter.addChild(image);
    }
}
